import React from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';
export function ComplexCases() {
  const tableData = [{
    sit: 'Tu hijo no tolera ningún cambio de rutina',
    sin: 'Improvisás y termina en crisis',
    con: 'Protocolo de transición gradual. Paso a paso.'
  }, {
    sit: 'Tiene hipersensibilidad sensorial',
    sin: 'Las actividades estándar lo sobreestimulan',
    con: 'Versión sensorial adaptada. Lista.'
  }, {
    sit: 'TDAH: no puede sostener ninguna actividad',
    sin: 'Abandona a los 2 minutos',
    con: 'Actividades de atención progresiva. Funcionan.'
  }, {
    sit: 'La rabieta dura más de 30 minutos',
    sin: 'No sabés cuándo ni cómo intervenir',
    con: 'Protocolo de regulación emocional completo.'
  }, {
    sit: 'Necesitás mostrarle algo al pediatra o psicólogo',
    sin: 'No tenés nada documentado',
    con: 'Registro de avances listo para imprimir.'
  }];
  const kitIncludes = ['Protocolo de transición para niños con baja tolerancia a la frustración', 'Actividades de regulación sensorial', 'Guía para familias con diagnóstico TEA y TDAH', 'Sistema de comunicación visual para niños no verbales', 'Registro de progreso para compartir con profesionales', 'Fichas de desescalada de crisis'];
  return <section className="bg-dark-800 py-20 px-4" data-id="element-36">
      <div className="max-w-5xl mx-auto" data-id="element-37">
        <div className="text-center mb-12" data-id="element-38">
          <h2 className="text-3xl md:text-4xl font-bold text-cream mb-4" data-id="element-39">
            🕊️ ¿QUÉ AGREGA EL KIT DE CASOS COMPLEJOS?
          </h2>
        </div>

        <div className="overflow-x-auto mb-12 rounded-2xl border border-primary/30 shadow-xl" data-id="element-40">
          <table className="w-full text-left border-collapse" data-id="element-41">
            <thead data-id="element-42">
              <tr className="bg-dark-900 border-b border-primary/30" data-id="element-43">
                <th className="p-4 text-cream font-bold w-1/3" data-id="element-44">
                  Situación en casa
                </th>
                <th className="p-4 font-bold w-1/3 flex items-center text-[#F59F0B]" data-id="element-45">
                  <XCircle className="w-5 h-5 mr-2" data-id="element-46" /> Sin Kit
                </th>
                <th className="p-4 text-cta font-bold w-1/3" data-id="element-47">
                  <div className="flex items-center text-[#CCC5BD]" data-id="element-48">
                    <CheckCircle2 className="w-5 h-5 mr-2" data-id="element-49" /> Con Kit
                  </div>
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-primary/10" data-id="element-50">
              {tableData.map((row, i) => <tr key={i} className="bg-dark-800 hover:bg-dark-900/50 transition-colors" data-id="element-51">
                  <td className="p-4 text-cream/90 font-medium" data-id="element-52">{row.sit}</td>
                  <td className="p-4 text-cream/60" data-id="element-53">{row.sin}</td>
                  <td className="p-4 text-primary font-medium" data-id="element-54">{row.con}</td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <div className="bg-primary-dark rounded-3xl p-8 md:p-10 border border-primary/30 max-w-3xl mx-auto" data-id="element-55">
          <h3 className="text-2xl font-bold text-cream mb-6 flex items-center" data-id="element-56">
            <span className="text-cta mr-3" data-id="element-57">✅</span> El Kit incluye:
          </h3>
          <ul className="space-y-4" data-id="element-58">
            {kitIncludes.map((item, i) => <li key={i} className="flex items-start text-cream/90" data-id="element-59">
                <CheckCircle2 className="w-6 h-6 text-primary mr-3 shrink-0" data-id="element-60" />
                <span className="text-lg" data-id="element-61">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}